module.exports = __webpack_public_path__ + "static/img/course1.332e308a.jpg";